import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import isArray from "lodash/isArray";
import isObject from "lodash/isObject";
import isString from "lodash/isString";
import isBoolean from "lodash/isBoolean";
import isFunction from "lodash/isFunction";

const typesWhiteList = [
    'text',
    'email',
    'phone',
    'radio',
    'select'
];

const validateMessages = (field, name) => {
    if (!field.required && !field.validation) {
        return true;
    }

    if (field.required
        && (
            !isObject(field.messages)
            || !isString(field.messages.empty)
            || isEmpty(field.messages.empty)
        )
    ) {
        console.warn('Required field must contains empty message');
        return false;
    }

    if (field.validation
        && (
            !isObject(field.messages)
            || !isString(field.messages.invalid)
            || isEmpty(field.messages.invalid)
        )
    ) {
        console.warn('Fields with validation must contains invalid message');
        return false;
    }

    return true;
};

const baseValidator = (field, name) => {
    if (!isEmpty(field.placeholder) && !isString(field.placeholder)) {
        console.warn(`Placeholder must be a string`);
        return false;
    }

    if (!isEmpty(field.required) && !isBoolean(field.required)) {
        console.warn(`Required must be boolean`);
        return false;
    }

    if (!isEmpty(field.validation) && !isFunction(field.validation)) {
        console.warn(`Validation must be a function`);
        return false;
    }

    return validateMessages(field, name);
};

const selectableValidator = (field, name) => {
    if (!isArray(field.values) || isEmpty(field.values)) {
        console.warn(`Values for selectable fields "${name}" must be an array`);
    }

    let passed = true;

    map(field.values, value => {
        if (value.value === undefined) {
            console.warn(`Value should not be empty`);
            passed = false;
        }

        if (!isString(value.name) || isEmpty(value.name)) {
            console.warn(`Value name must be not empty string`);
            passed = false;
        }
    });

    return passed && baseValidator(field, name);
};

const validators = {
    text: baseValidator,
    phone: baseValidator,
    email: baseValidator,
    radio: selectableValidator,
    select: selectableValidator,
};

export const fieldsMixin = {
    props: {
        /**
         * Поля формы
         */
        fields: {
            type: Object,
            required: true,
            validator: function (fields) {
                let validationPassed = true;

                map(fields, (field, name) => {
                    if (typesWhiteList.indexOf(field.type) === -1) {
                        console.warn(`Field "${name}" has incorrect type "${field.type}"`);
                        return validationPassed = false;
                    }

                    if (!validators[field.type](field, name)) {
                        return validationPassed = false;
                    }
                });

                return validationPassed;
            }
        },

        /**
         * Действие по отправке формы
         */
        onSubmit: {
            type: Function,
            required: true,
        },
    }
};

export const baseFormMixin = {
    props: {
        /**
         * Уникальный идентификатор
         */
        uniqueId: {
            type: String,
            required: true,
        },

        /**
         * Необходимо ли показывать кнопки "закрыть"
         */
        isModalForm: {
            type: Boolean,
            default: true,
        },

        /**
         * Заголовок формы
         */
        formTitle: {
            type: String,
            required: true,
        },

        /**
         * Подзаголовок формы
         */
        formSubTitle: {
            type: String,
            required: false,
        },

        /**
         * Цена. Указывается под формой
         */
        formPrice: {
            type: Number,
            required: false,
        },

        /**
         * Текст кнопки отправки
         */
        submitTitle: {
            type: String,
            required: true,
        },

        /**
         * Текст кнопки отправки
         */
        formClass: {
            type: String,
            required: false,
            default: 'request-form'
        },

        /**
         * Тема письма
         */
        theme: {
            type: String,
            required: false,
        },
    },
};


// WEBPACK FOOTER //
// ./resources/assets/js/mixins.js